




























































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ApiV2Service } from '@/services/api.base.service';
import AceEditor from 'vue2-ace-editor';
import Modal from '@/components/Modal.vue';
import 'brace/mode/javascript';
import 'brace/theme/clouds';
import TextareaCodeEditor from '@/components/TextareaCodeEditor.vue';

@Component({
  components: {
    TextareaCodeEditor,
    Modal,
    AceEditor,
  },
})
export default class MappingFunctions extends Vue {
  @Prop({ default: {} }) private deviceType!: any;
  private showHelp: boolean = false;
  private showTest: boolean = false;
  private testPayload: string = '';
  private testResponse: string = '';
  private dialog: boolean = false;
  private version: string = '0';
  private showTestFunctionModal: boolean = false;
  private toggleHelpModal: boolean = false;
  private validationWarnings: string = '';
  private testPort: string|undefined = undefined;

  private DEFAULT_MAPPING_FUNCTION = `(dataHexString) => {\n\treturn {\n\t\tfields: {\n\t\t}\n\t}\n}`;
  private DEFAULT_V2_MAPPING_FUNCTION = `(dataHexString) => {\n\treturn {\n\t\tmsgtype: [{\n\t\t}]\n\t}\n}`;
  private DEFAULT_V3_MAPPING_FUNCTION_SF_LR = `(dataBuffer) => {\n\treturn {\n\t\tmsgtype: [{\n\t\t}]\n\t}\n}`;
  private DEFAULT_V3_MAPPING_FUNCTION_OTHERS = `(messageJson) => {\n\treturn {\n\t\tmsgtype: [{\n\t\t}]\n\t}\n}`;

  private mounted() {
    Vue.set(this, 'version', this.deviceType.configuration.executionVersion);
  }

  private editorInit(editor: any) {
    editor.setOptions({
      fontSize: '1em',
    });
  }
  @Watch('deviceType', { deep: true, immediate: true })
  private setDefaultFunctions() {
    if (!this.deviceType.configuration.mappingFunction) {
      this.deviceType.configuration.mappingFunction = this.DEFAULT_MAPPING_FUNCTION;
    }
  }


  private async showTestFunction() {
    this.testResponse = '';
    this.showHelp = false;
    this.showTest = true;
  }

  private resetDialog() {
    this.dialog = false;
    this.version = this.deviceType.configuration.executionVersion;
    this.validationWarnings = '';
  }

  private changeExecVersion() {
    this.deviceType.configuration.executionVersion = this.version;
    switch (this.version) {
      case '1':
        this.deviceType.configuration.mappingFunction = this.DEFAULT_MAPPING_FUNCTION;
        break;
      case '2':
        this.deviceType.configuration.mappingFunction = this.DEFAULT_V2_MAPPING_FUNCTION;
        break;
      case '3':
      default:
        this.deviceType.configuration.mappingFunction = (this.deviceType.bearer === 'sigfox' || this.deviceType.bearer === 'lora') ? this.DEFAULT_V3_MAPPING_FUNCTION_SF_LR : this.DEFAULT_V3_MAPPING_FUNCTION_OTHERS;
        break;
    }
    this.dialog = false;
  }

  private validateModbusFunctionResponse(data: any) {
    for ( const key of Object.keys(data)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (const value2 of value) {
          if ((value2.modbusPayload && !value2.taskId) || (!value2.modbusPayload && value2.taskId)) {
            this.validationWarnings = '\'modbusPayload\' and \'taskId\' should both be present in local node measurements';
            break;
          }
        }
      } else {
        if ((value.modbusPayload && !value.taskId) || (!value.modbusPayload && value.taskId)) {
          this.validationWarnings = '\'modbusPayload\' and \'taskId\' should both be present in local node measurements';
          break;
        }
      }

    }
  }

  private async testFunction() {
    this.validationWarnings = '';
    const isJSON = this.deviceType.bearer !== 'sigfox' && this.deviceType.bearer !== 'lora';

    const strippedPayload = isJSON ? this.testPayload : this.testPayload.replace(/ /g, '');

    const { result } = await ApiV2Service.post(`admin/deviceVersion/test`, { code: this.deviceType.configuration.mappingFunction, executionVersion: `v${this.deviceType.configuration.executionVersion}`, payload: strippedPayload, isJSON, port: this.testPort });

    this.testResponse = JSON.stringify(result, null, '\t');
    if (this.deviceType.device_category === 'bridge' && this.deviceType.lan_protocol.toLowerCase() === 'modbus') {
      this.validateModbusFunctionResponse(result);
    }
    if (!this.testResponse) {
      this.testResponse = 'Empty response';
    }
  }

  private saveMappingFunction() {
    this.$emit('saveDeviceType', this.deviceType);
  }

  private async addToSchema() {
    const response = JSON.parse(this.testResponse);
    const schemaFields = this.deviceType.schema_fields;
    const fields: any[] = [];

    if (this.deviceType.configuration.executionVersion === '1') {
      const messageType = response.measurement || this.deviceType.slug;
      const existingFields = schemaFields.filter((schema: any) => schema.message_type === messageType);
      fields.push(this.addSchemaField(messageType, response.fields, existingFields));

    } else if (this.deviceType.configuration.executionVersion === '2') {
      const messageTypes = Object.keys(response);

      for (const messageType of messageTypes) {
        const messageTypeObj = Array.isArray(response[messageType]) ? response[messageType] : [response[messageType]];
        const existingFields = schemaFields.filter((schema: any) => schema.message_type === messageType);
        for (const point of messageTypeObj) {
          fields.push(this.addSchemaField(messageType, point, existingFields));
        }
      }
    }
    Vue.set(this.deviceType, 'schema_fields', schemaFields.concat(fields.flat()));
    this.saveMappingFunction();
  }

  private addSchemaField(messageType: string, point: any, existingFields: any[]) {
    const fieldsArr: any[] = [];
    const existingFieldList = existingFields.map((f) => f.fieldName);

    for (const field in point) {
      if (point.hasOwnProperty(field)) {
        const value = point[field];
        const type = this.deriveDataType(value);

        if (!existingFieldList.includes(field)) {
          fieldsArr.push({
            device_version_id: this.deviceType.id,
            direction: 'uplink',
            message_type: messageType,
            fieldName: field,
            // tslint:disable-next-line
            type: type,
          });
        }
      }
    }
    return fieldsArr;
  }

  private deriveDataType(value: number | string): string {
    if (typeof value === 'number') {
      if (Number.isInteger(value)) {
        return 'int';
      } else {
        return 'float';
      }
    } else if (typeof value === 'boolean') {
      return 'boolean';
    } else {
      return 'string';
    }
  }

  private execVersionOptions() {
    const opts = [
      {id: '1', name: '1 - Returns a single influx point'},
      {id: '2', name: '2 - multiple points; no fields key required'},
      {id: '3', name: '3 - data as a Buffer'},
    ];
    return opts.map((o) => ({
      id: o.id,
      name: o.name,
      active: o.id.toString() === this.deviceType.configuration.executionVersion,
    }));
  }

  private toggleHelp() {
    this.showTest = false;
    this.showHelp = !this.showHelp;
  }
}
